'use strict';

var base = require('../product/base');
var focusHelper = require('@sfra/components/focus');
var clientSideValidation = require('../components/clientSideValidation');
var ObserveElement = require('../util/observeElement');
var urlParameters = new URLSearchParams(window.location.search);
const cartInventoryError = urlParameters.get('CartInventoryError');
const applePayAddressError = urlParameters.get('APAddressError');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks if there is a product in the cart with an error related to the radial
 * @param {Array} items - AJAX response from the server
 */
function hasRadialError(items) {
    var cartInventoryErrorArray = cartInventoryError ? cartInventoryError.split(',') : [];
    var isRadialErrors = items.filter(i => cartInventoryErrorArray.includes(i.id)).length > 0;

    return isRadialErrors;
}

/**
 * Checks for a product with a radial-related error has been removed
 * @param {Array} items - AJAX response from the server
 */
function updateLocationAfterRemoveFromTheCart(items) {
    if (!hasRadialError(items)) {
        const actualPageUrl = new URL(window.location.href);
        if (actualPageUrl.search.indexOf('CartInventoryError' != -1)) {
            actualPageUrl.search = '';
            window.history.replaceState(null, null, actualPageUrl);
        }
    }
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    var $jsCartErrorMsg = $('.js-cart-error-msg');
    var $payPalCartButton = $('.paypal-cart-button');
    var hasInventoryError = cartInventoryError != null && cartInventoryError != '';
    var hasAPAddressError = applePayAddressError != null && applePayAddressError != '';

    if (data.valid.error || hasInventoryError || hasAPAddressError) {
        // Do not duplicate error messages on cart page
        // Iterate through received error messages and only append if the new error message isn't already in the DOM
        if ($jsCartErrorMsg.length > 0) {
            if (hasInventoryError) {
                if (!hasRadialError(data.items)) {
                    $('.valid-cart-error').addClass('d-none');
                }
            }

            var errorAlreadyInCart = $jsCartErrorMsg.filter(function (i, error) {
                var cartErrorMsg = $(error).attr('data-valid-cart-msg').replace(/\r?\n|\r/g, ' ');
                var commingError = data.valid.message ? data.valid.message.replace(/\r?\n|\r/g, ' ') : '';
                return commingError === '' || cartErrorMsg === commingError;
            });

            if (errorAlreadyInCart.length > 0) {
                // skip execution if the message already exists or comming error is empty
                return;
            }
        } else if (hasInventoryError) {
            return;
        }

        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button><span class="js-cart-error-msg" data-valid-cart-msg="' + data.valid.message + '">' + data.valid.message + '</span></div>';
            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
        if (!hasAPAddressError) {
            $('.checkout-btn').addClass('bbw-disable-cta');
            $payPalCartButton.addClass('bbw-disable-cta');
        }
    } else {
        $('.checkout-btn').removeClass('bbw-disable-cta');
        $payPalCartButton.removeClass('bbw-disable-cta');
        $('.valid-cart-error').addClass('d-none');

        if (window.ApplePaySession && $('isapplepay').length > 0) {
            location.reload();
        }
    }
}

function getSelectedShippingMethod(data) {
    return data.shipments[0].shippingMethods.filter(function (shippingMethod) {
        return data.shipments[0].selectedShippingMethod === shippingMethod.ID;
    })[0];
}

function basketCurrencyCode(data) {
    if (data.totals.basketCurrencyCode === null) {
        return '';
    }
    return ' ' + data.totals.basketCurrencyCode;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    var selectedShippingMethod = getSelectedShippingMethod(data);
    var selectedSMValue = selectedShippingMethod ? selectedShippingMethod.displayName : '';
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.js-cart-subtotal').empty().append(data.totals.subTotal + basketCurrencyCode(data));
    $('.js-selected-shipping-method').empty().append(selectedSMValue);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost + basketCurrencyCode(data));
    $('.tax-total').empty().append(data.totals.totalTax + basketCurrencyCode(data));
    if ($('.shipping-total-taxes').length > 0) {
        $('.shipping-total-taxes').empty().append(data.totals.totalTax + basketCurrencyCode(data));
    }
    $('.grand-total').empty().append(data.totals.grandTotal + basketCurrencyCode(data));
    $('.sub-total').empty().append(data.totals.subTotal + basketCurrencyCode(data));
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted + basketCurrencyCode(data));
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted + basketCurrencyCode(data));
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }

        if (item.renderedActivePromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedActivePromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }

        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });

    $(document).trigger('updateCartTotals', data);
}

/**
 * @function updateApprochingMessages
 * @desctiption - This function corrects all approaching messages upon updating quantities on cart
 * @param {Object} data - Basket model
 */
function updateApprochingMessages(data) {
    $('.js-promo-approaching-msg').remove();
    data.items.forEach(function (item) {
        if (item.promotions) {
            item.promotions.forEach(function (promo) {
                if (promo.approachingMsg && !promo.hideApproachingMessage) {
                    var $el = $('.cart-page .item-' + item.UUID);

                    $el.append($('<div>')
                        .html(promo.approachingMsg)
                        .addClass('js-promo-approaching-msg bbw-d-none bbw-promo-approaching-msg bbw-promo-active-details'));
                }
            });
        }
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the selection of shipping methods in the cart
 * @param {Object} shippingMethods - AJAX response from the server
 */
function updateShippingMethods(shippingMethods) {
    var $shippingMethod = $('.shippingMethods');
    $shippingMethod.empty();
    shippingMethods.forEach(function (item) {
        $shippingMethod.append(`<option ${item.selected ? 'selected' : ''} data-shipping-id="${item.ID}">${item.displayName} (${item.estimatedArrivalTime})</option>`);
    });
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += `<div class="approaching-discounts-wrapper">
                        <div class="single-approaching-discount text-center">
                            ${item.discountMsg}
                        </div>
                    </div>
                    `;
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getEditGiftModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade bbw-egift-edit-modal" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <svg class="svg-inline close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 792"><path fill="#333" d="M0 658l262.1-262L0 134l42.5-42.5 262 262.1L566.6 91.5l42.5 42.5L347 396l262.1 262-42.5 42.5-262.1-262-262 262z"/></svg>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html, containerSelector) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find(containerSelector ? containerSelector : '.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}


/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate, '.js-bbw-egift-wrapper');

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();

            addSpecialCharValidations();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Prevents users from submitting certain characters into certain fields.
 */
function addSpecialCharValidations() {
    // TODO: this is a copy-paste of cartridges\app_bbw_ca\cartridge\client\default\js\components\regexForms.js. We need to reuse that code here instead.

    $('.no-special-chars').on('change keyup mouseleave', function () {
        var fieldValue = $(this).val();
        fieldValue = fieldValue.replace(/[’´]/g, '\'')
            .replace(/Æ/g, 'AE')
            .replace(/æ/g, 'ae')
            .replace(/Œ/g, 'OE')
            .replace(/œ/g, 'oe')
            .replace(/&/g, 'and')
            .replace(/ᵉ/g, 'e')
            .replace(/ē/g, 'é')
            .replace(/–/g, '-')
            .replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ' \. \-]/g, ''); // eslint-disable-line
        $(this).val(fieldValue);
    });

    $('.no-special-chars-message').on('change keyup mouseleave', function () {
        var fieldValue = $(this).val();
        fieldValue = fieldValue.replace(/[’´]/g, '\'')
            .replace(/Æ/g, 'AE')
            .replace(/æ/g, 'ae')
            .replace(/Œ/g, 'OE')
            .replace(/œ/g, 'oe')
            .replace(/&/g, 'and')
            .replace(/ᵉ/g, 'e')
            .replace(/ē/g, 'é')
            .replace(/–/g, '-')
            .replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'?!:;,.\(\) \. \-]/g, ''); // eslint-disable-line
        $(this).val(fieldValue);
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {string} productCategory - product category
 */
function confirmDelete(actionUrl, productID, productName, uuid, productCategory, isGiftCardRemoved) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    $deleteConfirmBtn.data('category', productCategory);
    $deleteConfirmBtn.data('is-giftcard', isGiftCardRemoved);

    $productToRemoveSpan.empty().append(productName);
    if (productCategory) {
        var $categoryToRemoveSpan = $('.category-to-remove');
        $categoryToRemoveSpan.empty().append(productCategory);
    }
}

/**
 * Set radial fraud ID to basket model
 */
function setRDFUID() {
    let inputBox = document.querySelector('#RDFUID');

    if (!inputBox) {
        return;
    }

    var url = document.querySelector('#RDFUID').dataset.url;

    ObserveElement.observeElement(inputBox, 'value', function (oldValue, newValue) {
        if (newValue === '') {
            return;
        }

        $.ajax({
            url,
            method: 'POST',
            dataType: 'json',
            data: { rdfuid: newValue }
        }).done(function () {
            $(document).trigger('setRDFUID');
        });
    });
}

/**
 * Refresh Cart Page After eGfit Card is removed and there is
 * no eGift Card in the cart to can render the apple pay buttons
 */
function refreshCartAftereGiftIsRemoved(data) {
    if (window.ApplePaySession) {
        if (!data) {
            return;
        }

        var cgInCart = data.basket.items.filter(item => item.isGiftCard).length;

        if (cgInCart === 0 && data.isGiftCardRemoved) {
            location.reload();
        }
    }
}

function addAppliedPromoClass() {
    $('.js-applied-promotion').closest('.card').addClass('bbw-with-applied-promo');
}

function toggleAppliedPromoClass(data, uuid) {
    var $productCard = $('.card.uuid-' + uuid);

    if (!data || $productCard.length === 0) {
        return;
    }

    $productCard.toggleClass('bbw-with-applied-promo', $productCard.find('.js-applied-promotion').length > 0);
}

/**
 * Updates the product selection view for removal
 * @param {Object} data - AJAX response from the server
 */
function refreshSelectionOfProductsForRemoval(data) {
    var $productsToRemoveWrapper = $('.js-products-to-remove-wrapper');
    var $globalDivider = $('.js-products-to-remove-global-divider');
    var hazmatProductsQty = data.basket.bbwHazmatProductsToRemove;

    if (hazmatProductsQty === 0) {
        $productsToRemoveWrapper.remove();
        $globalDivider.remove();
    }

    if (hazmatProductsQty !== 0) {
        $('.js-products-to-remove-divider').each(function (index) {
            if (index + 1 === data.basket.bbwHazmatProductsToRemove) {
                $(this).remove();
            }
        });
    }

    if (hazmatProductsQty === data.basket.items.length) {
        $('.js-products-to-remove-global-divider').hide();
    }

    if (hazmatProductsQty === 1) {
        var textSingleItem = $('input[name$="textSingleItem"').length > 0 ? $('input[name$="textSingleItem"').val() : '';

        $productsToRemoveWrapper.find('.js-products-to-remove-msg').text(textSingleItem);
    }
}

/**
 * Updated DOM based on discount line items. Render the bonus product CTA.
 * @param {Object} data - basket model data
 */
function updateDiscountLineItems(data) {
    if (!data) {
        return;
    }

    var items = data.items || data.basket.items;

    var lineItems = items.length > 0 ? items : [];
    var template = '';

    // Loop thru each line items
    for (var i = 0; i < lineItems.length; i++) {
        var lineItem = lineItems[i];
        var discountLineItems = lineItem.discountLineItems;

        // Look thru each discount line item from each line item
        for (var j = 0; j < discountLineItems.length; j++) {
            var discountLineItem = discountLineItems[j];
            // Bonus product CTA
            template += `
            <div class="bonus-product-wrapper js-bonus-product-wrapper">
                <div
                    class="bonus-product-button js-bonus-product-button"
                    data-duuid="${discountLineItem.uuid}"
                    data-pliuuid="${discountLineItem.pliuuid}"
                    data-maxpids="${discountLineItem.maxpids}"
                    data-pageStart="0"
                    data-pageSize="0"
                    data-url="${discountLineItem.url}"
                >
                    <button class="btn btn-outline-primary bbw-text-uppercase" data-toggle="modal" data-target="#chooseBonusProductModal">
                        ${discountLineItem.msg}
                    </button>
                </div>
            </div>`;
        }

        var $productCard = $('.card.product-info.uuid-' + lineItem.UUID);
        var $bonusProductCTAWrapper = $productCard.find('.js-bonus-product-wrapper');
        var $bonusLineItems = $productCard.find('.bundled-line-item');
        var $bonusMsg = $productCard.find('.bonus-line-item-msg');
        var isBonusProductLineItemModal = 'bonusProductLineItemModal' in lineItem ? JSON.parse(lineItem.bonusProductLineItemModal) : '';
        var bonusModalWasRendered = $productCard.attr('data-modal-was-rendered') ? JSON.parse($productCard.attr('data-modal-was-rendered')) : false;
        var isOpenModalProductModal = $productCard.attr('data-open-bonus-product-modal') ? JSON.parse($productCard.attr('data-open-bonus-product-modal')) : '';
        // If we have discount line items and the CTA is not on DOM we add it
        if (lineItem.discountLineItems && lineItem.discountLineItems.length > 0 && $bonusProductCTAWrapper.length === 0) {
            $productCard.append($(template));
        }

        // Remove the bonus products if we don't have discount line item
        if (lineItem.discountLineItems && lineItem.discountLineItems.length === 0) {
            $bonusProductCTAWrapper.remove();
            $bonusLineItems.remove();
            $bonusMsg.remove();
        }

        // If data attribute and isBonusProductLineItemModal are not set reset the isBonusProductLineItemModal
        if (isOpenModalProductModal !== '' && isBonusProductLineItemModal === '') {
            isBonusProductLineItemModal = false;
        }

        if (isBonusProductLineItemModal !== '') {
            // Update Open Bonus Modal data attribute
            $productCard.attr('data-open-bonus-product-modal', isBonusProductLineItemModal);
        }


        // Render once bonus modal if was not rendered
        if (isBonusProductLineItemModal !== '' && isBonusProductLineItemModal && !bonusModalWasRendered) {
            $('.card.product-info[data-open-bonus-product-modal="true"] .js-bonus-product-button').trigger('click');
            $productCard.attr('data-modal-was-rendered', true);
        }

        // Reset the modal to be re rendered if promo was reset it
        if (isBonusProductLineItemModal !== '' && !isBonusProductLineItemModal) {
            $productCard.attr('data-modal-was-rendered', false);
        }

        // reset template for each item
        template = '';
    }
}

/**
 * Updated DOM based on bonus line items. Refresh the page and render the bonus product line item
 * @param {Object} data - basket model data
 */
function updateBonusProductLineItem(data) {
    if (!data) {
        return;
    }

    var items = data.items || data.basket.items;

    var bonusProductLineItemsInDOM = $('.js-bonus-product-line-item').length; // Number of bonus product line items in DOM
    var bonusLineItemsFromBasket = items.filter((lineItem) => lineItem.isBonusProductLineItem).length; // Number bonus line items from basket

    // Loop thru product line item from basket
    for (var i = 0; i < items.length; i++) {
        var productLineItem = items[i];
        var UUID = productLineItem.UUID;
        var $currentBonusProductLineItem = $('.js-bonus-product-line-item.uuid-' + UUID);

        if ($currentBonusProductLineItem.length === 1) {
            // Decrease the bonus product line items from DOM and Basket based on the current bonus line item from DOM
            bonusProductLineItemsInDOM -= 1;
            bonusLineItemsFromBasket -= 1;
        }
    }

    if (bonusProductLineItemsInDOM !== 0 || bonusLineItemsFromBasket !== 0) {
        // Reload the cart page if a at least one bonus product is present in DOM or Basket
        location.reload();
    }
}

function updateCbtProductsInGA4Format(items) {
    let formattedItems = [];

    for (let i = 0; i < items.length; i++) {
        var item = items[i];
        formattedItems.push({
            'item_id'       : item.id,
            'item_name'     : item.productName.replace('"', '').replace('\'', ''),
            'item_brand'    : item.brand || '',
            'item_category' : item.primaryCategoryName,
            'item_variant'  : item.size || '',
            'price'    : (item.priceTotal.priceValue / item.quantity).toFixed(2),
            'quantity' : item.quantity
        });
    }

    return formattedItems;
}

function updateCBTDataLayer(data) {
    var checkoutButtons = $('.js-begin-checkout');

    if (checkoutButtons.length > 0) {
        var dataLayer = checkoutButtons[0].dataset.cbtBeginCheckoutMinicart ? JSON.parse(checkoutButtons[0].dataset.cbtBeginCheckoutMinicart) : JSON.parse(checkoutButtons[0].dataset.cbtBeginCheckout);
        var basket = data.basket ? data.basket : data;
        dataLayer.ecommerce.value = basket.totals.grandTotalAfterGCValue.toFixed(2);
        dataLayer.ecommerce.items = basket.items && basket.items.length > 0 ? updateCbtProductsInGA4Format(basket.items) : [];
        for (var i = 0; i < checkoutButtons.length; i++) {
            var checkoutButton = checkoutButtons[i];
            if (checkoutButton.dataset.cbtBeginCheckoutMinicart) {
                checkoutButton.dataset.cbtBeginCheckoutMinicart = JSON.stringify(dataLayer);
            } else {
                checkoutButton.dataset.cbtBeginCheckout = JSON.stringify(dataLayer);
            }
        }
    }
}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var productCategory = $(this).data('category');
        var isGiftCardRemoved = $(this).data('is-giftcard');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid, productCategory, isGiftCardRemoved);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid, data.productCategory);
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var isGiftCardRemoved = $(this).data('is-giftcard');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        if ($('.js-products-to-remove-wrapper').length > 0) {
            urlParams.removeHazmatItems = true;
        }

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.cart').empty().append(
                        '<div class="container cart-empty bbw-cart-empty"> ' +
                        '<div class="row"> ' +
                        '<div class="col-12 text-center"> ' +
                        '<p class="bbw-ce-title bbw-font--source-sans-pro-bold">' + data.basket.resources.emptyCartMsg + '</p> ' +
                        '</div> ' +
                        '<div class="col-12 text-center"> ' +
                        '<a class="btn btn-primary btn-block bbw-ce-cta bbw-text-uppercase" href=' + data.basket.resources.homepageUrl + '>' + data.basket.resources.continueShopping + '</a> ' +
                        '</div> ' +
                        '</div> ' +
                        '</div>'
                    );
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    updateLocationAfterRemoveFromTheCart(data.basket.items);
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateShippingMethods(data.basket.shipments[0].shippingMethods);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    updateApprochingMessages(data.basket);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                    updateLocationAfterRemoveFromTheCart(data.basket.items);

                    data.isGiftCardRemoved = isGiftCardRemoved;
                    refreshCartAftereGiftIsRemoved(data);
                    toggleAppliedPromoClass(data, uuid);
                }

                refreshSelectionOfProductsForRemoval(data);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            preSelectQty: preSelectQty,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(data.updatedQuantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                toggleAppliedPromoClass(data, uuid);
                $(this).data('pre-select-qty', data.updatedQuantity);

                $('body').trigger('cart:update', data);

                $(this).val(parseInt(data.updatedQuantity, 10));
                updateApprochingMessages(data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateApprochingMessages(data);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateApprochingMessages(data);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();

        if (!$('#realTimeInventoryModal').hasClass('show')) {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').first().focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('click', '.js-edit-egiftcard', function (e) {
        e.preventDefault();
        var editProductUrl = $(this).attr('href');

        getEditGiftModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        var $giftCardModal = $(this);
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();

        if ($giftCardModal.hasClass('bbw-egift-edit-modal')) {
            var $form = $giftCardModal.find('form');
            clientSideValidation.invalid();

            $form.on('submit', function (e) {
                e.preventDefault();

                if (!clientSideValidation.functions.validateForm($form, e)) {
                    return;
                }

                var $this = $(this);
                var $submitBtn = $this.find('.js-update-egift-card');
                var url = $submitBtn.data('update-url');
                var uuid = $submitBtn.data('uuid');

                var data = {
                    uuid: uuid,
                    gcRecipient: $this.find('#giftcard-to').val() || '',
                    gcSender: $this.find('#giftcard-from').val(),
                    gcRecipientEmail: $this.find('#giftcard-email').val() || '',
                    gcAmount: $this.find('#giftcard-amount').val() || '',
                    gcMessage: $this.find('#giftcard-message').val() || ''
                };

                $giftCardModal.spinner().start();

                $.ajax({
                    url: url,
                    data: data
                }).done(function (response) {
                    if (!response.error) {
                        location.reload();
                    }
                }).always(function () {
                    $giftCardModal.spinner().stop();
                });
            });
        }
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);
                    toggleAppliedPromoClass(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.js-continue-shopping', function (e) {
        e.preventDefault();
        window.history.back();
    });

    $('body').on('setShippingMethodSelection', function (e, basket) {
        var $cartSMContainer = $('.js-cart-shipping-method-container');

        if (basket.allItemsAreEGiftCards && $cartSMContainer.length > 0) {
            $cartSMContainer.remove();
        }
    });

    $(document).on('updateCartTotals', function (e, basket) {
        var $totalTaxContainer = $('.js-cart-total-tax-container');
        var $totalShippingMethodContainer = $('.js-cart-sm-totals-container');

        $totalTaxContainer.removeClass('d-none');
        $totalShippingMethodContainer.removeClass('d-none');

        if (basket.allItemsAreEGiftCards) {
            $totalShippingMethodContainer.addClass('d-none');
        } else {
            let shipments = basket.shipments[0];
            let shippingMethods = shipments.shippingMethods;
            let $shippingMethodContainer = $totalShippingMethodContainer.find('.js-shipping-method-label');

            $shippingMethodContainer.empty();

            for (var i = 0; i < shippingMethods.length; i++) {
                if (shipments.selectedShippingMethod === shippingMethods[i].ID) {
                    var template = `<p class="bbw-cart-summary-lbl">
                            ${basket.resources.estimatedShippingLabel} -
                            <span class="js-selected-shipping-method">
                                ${shippingMethods[i].displayName}
                            </span>
                        </p>`;

                    $shippingMethodContainer.append(template);
                }
            }
        }

        if (basket.totals.totalTaxValue === 0) {
            $totalTaxContainer.removeClass('d-none');
        }
    });

    if (window.ApplePaySession) {
        $(document).on('setRDFUID', function () {
            var $cartBtns = $('.js-cbtn-container');
            $cartBtns.removeClass('d-none');
        });

        setRDFUID();
    } else {
        var $cartBtnsContainer = $('.js-cbtn-container');
        $cartBtnsContainer.removeClass('d-none');
    }

    /*
     * Triggered when coupon is added or removed with success
     * The functionality inside is to refresh the cart page if a coupon with a bonus product line item is added or removed
     */
    $('body').on('promotion:success', function (e, data) {
        updateBonusProductLineItem(data);
        updateDiscountLineItems(data);
        updateCBTDataLayer(data);
    });

    /*
     * Triggered when cart is updated
     */
    $('body').on('cart:update', function (e, data) {
        updateDiscountLineItems(data);
        updateBonusProductLineItem(data);
        updateCBTDataLayer(data);
    });

    // If modal was not rendered and promo is coupon based render bonus product modal at page load
    $('.card.product-info[data-open-bonus-product-modal="true"][data-modal-was-rendered="false"] .js-bonus-product-button').trigger('click');

    $('[data-cbt-begin-checkout]').each(function () {
        var $this = $(this);
        $this.on('click', function () {
            var cbtData = $this.data('cbt-begin-checkout');
            if (cbtData) {
                window.dataLayer.push(cbtData);
            }
        });
    });

    addAppliedPromoClass();

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
